/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MaintenanceScheduleResponse = {
  id: number;
  /**
   * 차대번호
   */
  vin: string;
  /**
   * 소모품 명
   */
  sestName: string;
  /**
   * 소모품 코드
   */
  sestCode: string;
  /**
   * 기준 일 수
   */
  stdType: MaintenanceScheduleResponse.stdType;
  /**
   * 관리주기 타입: 복합: 0, 거리::1 , 일자:2 (COMBINED, DISTANCE, DAY)
   */
  maintenanceType: MaintenanceScheduleResponse.maintenanceType;
  /**
   * 유저설정 기준 주행거리
   */
  customStdDistance: number;
  /**
   * 유저설정 기준 일 수
   */
  customStdDays: number;
  /**
   * 기준 주행거리
   */
  stdDistance: number;
  /**
   * 기준 일 수
   */
  stdDays: number;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
};
export namespace MaintenanceScheduleResponse {
  /**
   * 기준 일 수
   */
  export enum stdType {
    OWNER_MANUAL = 'OWNER_MANUAL',
    CUSTOM = 'CUSTOM',
  }
  /**
   * 관리주기 타입: 복합: 0, 거리::1 , 일자:2 (COMBINED, DISTANCE, DAY)
   */
  export enum maintenanceType {
    COMBINED = 'COMBINED',
    DISTANCE = 'DISTANCE',
    DAY = 'DAY',
  }
}

